import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import { DiscoIcon, DiscoIconButton } from "@disco-ui"
import DiscoSidebarHeader from "@disco-ui/sidebar/DiscoSidebarHeader"

export default function BrainSearchSidebarHeader() {
  const bot = useBrainSearchBot()
  const drawer = useGlobalDrawer("brainSearch")

  if (!bot) return null
  return (
    <DiscoSidebarHeader
      title={bot.name}
      icon={"stars"}
      actions={
        <DiscoIconButton
          onClick={() => drawer.setParams({ convId: undefined })}
          width={24}
          height={24}
          tooltip={"New AI Conversation"}
        >
          <DiscoIcon icon={"add"} width={24} height={24} />
        </DiscoIconButton>
      }
    />
  )
}
